import { useState } from 'react';

// Bottom compose row — borderless transparent textarea + 28x28 send button.
// No quick-jump nav row (explicitly removed in the design README).

export function CoachCompose({ onSend }) {
  const [draft, setDraft] = useState('');

  const handleSend = () => {
    const trimmed = draft.trim();
    if (!trimmed) return;
    onSend?.(trimmed);
    setDraft('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="coach-compose"
      style={{ display: 'flex', alignItems: 'flex-end', gap: 8 }}
    >
      <textarea
        rows={1}
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Write to your coach…"
        style={{
          flex: 1, minHeight: 22, maxHeight: 120, resize: 'none',
          background: 'transparent', border: 0, outline: 'none',
          fontFamily: 'var(--sans)', fontSize: 13.5, lineHeight: 1.4,
          color: 'var(--ink)',
        }}
      />
      <button
        type="button"
        onClick={handleSend}
        title="Send"
        aria-label="Send message"
        style={{
          width: 28, height: 28, display: 'grid', placeItems: 'center',
          border: '1px solid var(--ink)', background: 'var(--ink)',
          color: 'var(--paper)', fontFamily: 'var(--mono)', fontSize: 12,
          cursor: 'pointer',
        }}
      >
        ↵
      </button>
    </div>
  );
}

export default CoachCompose;
